/* eslint-disable */
/* tslint:disable */
// @ts-ignore
export default {
    width: 16,
    height: 16,
    viewBox: '0 0 36.5 36.5',
    data: '<path pid="0" d="M28.25 14.02h-20V8.25h20v5.77zM9.5 12.77H27V9.5H9.5v3.27zM28.25 21.14h-20v-5.77h20v5.77zM9.5 19.89H27v-3.27H9.5v3.27zM28.25 28.25h-20v-5.77h20v5.77zM9.5 27H27v-3.27H9.5V27z" _fill="#6ebe44"/>'
}
